module.exports = __webpack_public_path__ + "img/bill.3c68be40.png";